@charset "UTF-8";

/* libs/shared/src/lib/ui/datatable/datatable.component.scss */
.ngx-datatable.material {
  box-shadow: none;
  position: relative;
  max-height: 100%;
  border-radius: var(--radius-lg);
  overflow: hidden;
  border: 1px solid var(--background-border);
}
.searchbar-wrapper {
  display: flex;
  flex-direction: row;
  gap: var(--space-sm);
  align-items: center;
}
.searchbar-wrapper .dt-actions-slot {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}
.searchbar-wrapper .search-group {
  display: flex;
  align-items: stretch;
}
.searchbar-wrapper .search-group .input-wrap {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  width: 340px;
  height: 38px;
  padding: 0 12px;
  border: 1px solid var(--background-border);
  border-right: none;
  border-radius: var(--radius-md) 0 0 var(--radius-md);
  background: var(--background-white);
  transition: var(--transition-fast);
}
.searchbar-wrapper .search-group .input-wrap:focus-within {
  border-color: var(--primary-color);
}
.searchbar-wrapper .search-group .input-wrap .search-icon {
  flex: none;
  color: var(--text-muted);
  font-size: 13px;
}
.searchbar-wrapper .search-group .input-wrap .search-input {
  border: none;
  border-bottom: none;
  outline: none;
  width: 100%;
  font-size: 14px;
  color: var(--text-primary);
  background: transparent;
}
.searchbar-wrapper .search-group .input-wrap .search-input::placeholder {
  color: var(--text-muted);
}
.searchbar-wrapper .search-group .submit-button.search-button {
  height: 38px;
  border-radius: 0 var(--radius-md) var(--radius-md) 0;
  box-shadow: none;
}
.searchbar-wrapper .search-group .submit-button.search-button:hover {
  transform: none;
  box-shadow: none;
}
.action-list-custom .btn-action[data-tooltip=Delete] {
  background: var(--error-red) !important;
}
.action-list-custom .btn-action[data-tooltip=Delete]:hover {
  background: var(--error-red-hover) !important;
}
.action-list-custom .btn-action:has(i.fa-trash) {
  background: var(--error-red) !important;
}
.action-list-custom .btn-action:has(i.fa-trash):hover {
  background: var(--error-red-hover) !important;
}
.datatable-body-cell-label {
  overflow-wrap: break-word !important;
  font-size: 14px !important;
  color: var(--text-secondary);
  line-height: 1.5;
}
.datatable-super-upper-wrap {
  position: relative;
}
.datatable-upper-wrap {
  margin-top: var(--space-xl);
  overflow: visible;
  position: relative;
  z-index: 2;
}
.action-buttons,
.action-buttons-wrapper {
  position: relative;
  display: flex;
  gap: var(--space-sm);
  align-items: center;
  justify-content: center;
}
.action-buttons .btn,
.action-buttons-wrapper .btn {
  border-radius: var(--radius-md);
  border: none;
  transition: var(--transition-fast);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  font-size: 12px;
  position: relative;
}
.action-buttons .btn.btn-action,
.action-buttons-wrapper .btn.btn-action {
  box-shadow: var(--shadow-sm);
}
.action-buttons .btn.btn-action:hover,
.action-buttons-wrapper .btn.btn-action:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}
.action-buttons .btn.btn-action:active,
.action-buttons-wrapper .btn.btn-action:active {
  transform: translateY(0);
  box-shadow: var(--shadow-sm);
}
.action-buttons .btn.btn-action[data-tooltip*=Edit],
.action-buttons .btn.btn-action[data-tooltip*=EDIT],
.action-buttons-wrapper .btn.btn-action[data-tooltip*=Edit],
.action-buttons-wrapper .btn.btn-action[data-tooltip*=EDIT] {
  background: var(--primary-color);
  color: white;
}
.action-buttons .btn.btn-action[data-tooltip*=Edit]:hover,
.action-buttons .btn.btn-action[data-tooltip*=EDIT]:hover,
.action-buttons-wrapper .btn.btn-action[data-tooltip*=Edit]:hover,
.action-buttons-wrapper .btn.btn-action[data-tooltip*=EDIT]:hover {
  background: var(--primary-color-hover);
}
.action-buttons .btn.btn-action[data-tooltip*=Delete],
.action-buttons .btn.btn-action[data-tooltip*=DELETE],
.action-buttons-wrapper .btn.btn-action[data-tooltip*=Delete],
.action-buttons-wrapper .btn.btn-action[data-tooltip*=DELETE] {
  background: var(--error-red);
  color: white;
}
.action-buttons .btn.btn-action[data-tooltip*=Delete]:hover,
.action-buttons .btn.btn-action[data-tooltip*=DELETE]:hover,
.action-buttons-wrapper .btn.btn-action[data-tooltip*=Delete]:hover,
.action-buttons-wrapper .btn.btn-action[data-tooltip*=DELETE]:hover {
  background: var(--error-red-hover);
}
.action-buttons .btn.btn-action.save-button,
.action-buttons .btn.btn-action[data-tooltip*=Save],
.action-buttons .btn.btn-action[data-tooltip*=SAVE],
.action-buttons-wrapper .btn.btn-action.save-button,
.action-buttons-wrapper .btn.btn-action[data-tooltip*=Save],
.action-buttons-wrapper .btn.btn-action[data-tooltip*=SAVE] {
  background: var(--success-green);
  color: white;
}
.action-buttons .btn.btn-action.save-button:hover,
.action-buttons .btn.btn-action[data-tooltip*=Save]:hover,
.action-buttons .btn.btn-action[data-tooltip*=SAVE]:hover,
.action-buttons-wrapper .btn.btn-action.save-button:hover,
.action-buttons-wrapper .btn.btn-action[data-tooltip*=Save]:hover,
.action-buttons-wrapper .btn.btn-action[data-tooltip*=SAVE]:hover {
  background: var(--success-green-hover);
}
.action-buttons .btn.btn-action[data-tooltip*=Cancel],
.action-buttons .btn.btn-action[data-tooltip*=CANCEL],
.action-buttons-wrapper .btn.btn-action[data-tooltip*=Cancel],
.action-buttons-wrapper .btn.btn-action[data-tooltip*=CANCEL] {
  background: var(--text-muted);
  color: white;
}
.action-buttons .btn.btn-action[data-tooltip*=Cancel]:hover,
.action-buttons .btn.btn-action[data-tooltip*=CANCEL]:hover,
.action-buttons-wrapper .btn.btn-action[data-tooltip*=Cancel]:hover,
.action-buttons-wrapper .btn.btn-action[data-tooltip*=CANCEL]:hover {
  background: var(--text-secondary);
}
.action-buttons .btn.btn-action[data-tooltip*=View],
.action-buttons .btn.btn-action[data-tooltip*=VIEW],
.action-buttons-wrapper .btn.btn-action[data-tooltip*=View],
.action-buttons-wrapper .btn.btn-action[data-tooltip*=VIEW] {
  background: var(--secondary-orange);
  color: white;
}
.action-buttons .btn.btn-action[data-tooltip*=View]:hover,
.action-buttons .btn.btn-action[data-tooltip*=VIEW]:hover,
.action-buttons-wrapper .btn.btn-action[data-tooltip*=View]:hover,
.action-buttons-wrapper .btn.btn-action[data-tooltip*=VIEW]:hover {
  background: var(--secondary-orange-hover);
}
.action-buttons .btn i,
.action-buttons-wrapper .btn i {
  font-size: 12px;
  line-height: 1;
}
.action-buttons .save-button,
.action-buttons-wrapper .save-button {
  position: relative;
  margin-right: var(--space-xs);
}
.action-list-custom {
  display: flex;
  gap: var(--space-sm);
  justify-content: center;
  align-items: center;
}
.action-list-custom .action-item .btn.btn-primary {
  background: var(--primary-color);
  border: none;
  color: white;
  border-radius: var(--radius-sm);
  font-size: 13px;
  font-weight: 500;
  transition: var(--transition-fast);
  box-shadow: var(--shadow-sm);
}
.action-list-custom .action-item .btn.btn-primary:hover {
  background: var(--primary-color-hover);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}
.action-list-custom .action-item .btn.btn-primary:active {
  transform: translateY(0);
  box-shadow: var(--shadow-sm);
}
.tooltip.tooltip-left::before {
  background: var(--text-primary);
  color: white;
  font-size: 12px;
  padding: var(--space-xs) var(--space-sm);
  border-radius: var(--radius-sm);
  white-space: nowrap;
}
.submit-button.search-button {
  height: 36px;
  padding: var(--space-xs) var(--space-md);
  background: var(--primary-color);
  border: none;
  border-radius: var(--radius-md);
  color: white;
  font-weight: 500;
  font-size: 14px;
  transition: var(--transition-fast);
  cursor: pointer;
  box-shadow: var(--shadow-sm);
}
.submit-button.search-button:hover {
  background: var(--primary-color-hover);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}
.submit-button.search-button:active {
  transform: translateY(0);
  box-shadow: var(--shadow-sm);
}
.submit-button.search-button:disabled {
  background: var(--text-muted);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
@media (max-width: 768px) {
  .action-buttons,
  .action-buttons-wrapper {
    gap: var(--space-xs);
  }
  .action-buttons .btn,
  .action-buttons-wrapper .btn {
    min-width: 30px;
    height: 30px;
    padding: var(--space-xs);
  }
  .action-buttons .btn i,
  .action-buttons-wrapper .btn i {
    font-size: 11px;
  }
}
.submit-button.search-button {
  height: 42px;
  padding: var(--space-sm) var(--space-md);
  background: var(--primary-color);
  border: none;
  border-radius: var(--radius-md);
  color: white;
  font-weight: 500;
  transition: var(--transition-fast);
  cursor: pointer;
}
.submit-button.search-button:hover {
  background: var(--primary-color-hover);
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}
.submit-button.search-button:disabled {
  background: var(--text-muted);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.configure-columns-wrapper {
  cursor: pointer;
  position: relative;
}
.configure-columns-wrapper .edit-columns-wrapper {
  background: var(--background-light);
  border: 2px solid var(--background-border);
  border-radius: var(--radius-md);
  height: 42px;
  width: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition-fast);
}
.configure-columns-wrapper .edit-columns-wrapper:hover {
  border-color: var(--primary-color);
  background: var(--primary-color-light);
}
.configure-columns-wrapper .edit-columns-wrapper .edit-columns-icon {
  font-size: 1.1rem;
  line-height: 1;
  color: var(--primary-color);
  opacity: 0.7;
  transition: var(--transition-fast);
}
.configure-columns-wrapper .edit-columns-wrapper:hover .edit-columns-icon {
  opacity: 1;
}
.column-settings-wrapper {
  position: absolute;
  right: 0;
  top: 100%;
  z-index: 30;
  margin-top: var(--space-sm);
}
.col-filter {
  width: 288px;
  background: var(--background-white);
  border: 1px solid var(--background-border);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.16);
  overflow: hidden;
  cursor: default;
}
.col-filter .cf-box {
  width: 18px;
  height: 18px;
  flex: none;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid var(--background-border);
  background: var(--background-white);
  color: #fff;
  font-size: 10px;
}
.col-filter .cf-box.checked {
  border-color: var(--primary-color);
  background: var(--primary-color);
}
.col-filter .cf-head {
  display: flex;
  align-items: center;
  padding: 13px 16px;
  border-bottom: 1px solid var(--background-lighter);
}
.col-filter .cf-head .cf-title {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--text-primary);
}
.col-filter .cf-head .cf-close {
  margin-left: auto;
  width: 26px;
  height: 26px;
  border: none;
  background: transparent;
  border-radius: 6px;
  color: var(--text-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  line-height: 1;
}
.col-filter .cf-head .cf-close:hover {
  background: var(--background-light);
  color: var(--text-primary);
}
.col-filter .cf-showall {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  border-bottom: 1px solid var(--background-lighter);
}
.col-filter .cf-showall:hover {
  background: var(--background-light);
}
.col-filter .cf-showall .cf-showall-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
}
.col-filter .cf-list {
  padding: 6px 6px 8px;
  max-height: 320px;
  overflow-y: auto;
}
.col-filter .cf-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  background: var(--background-white);
}
.col-filter .cf-row:hover {
  background: var(--background-light);
}
.col-filter .cf-row .cf-grip {
  color: var(--background-border);
  display: flex;
  cursor: grab;
}
.col-filter .cf-row .cf-grip:active {
  cursor: grabbing;
}
.col-filter .cf-row .cf-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  padding: 0;
  min-width: 0;
}
.col-filter .cf-row .cf-toggle .cf-label {
  font-size: 13px;
  color: var(--text-secondary);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.col-filter .cf-row .cf-toggle .cf-label.muted {
  color: var(--text-muted);
  font-weight: 400;
}
.col-filter .cf-row .cf-arrows {
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.col-filter .cf-row .cf-arrows .cf-arrow {
  width: 18px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  color: var(--text-muted);
  padding: 0;
}
.col-filter .cf-row .cf-arrows .cf-arrow i {
  font-size: 9px;
}
.col-filter .cf-row .cf-arrows .cf-arrow:hover:not(:disabled) {
  background: var(--background-lighter);
  color: var(--text-primary);
}
.col-filter .cf-row .cf-arrows .cf-arrow:disabled {
  color: var(--background-border);
  cursor: default;
}
.col-filter .cf-foot {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border-top: 1px solid var(--background-lighter);
  background: var(--background-light);
}
.col-filter .cf-foot .cf-reset {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-secondary);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}
.col-filter .cf-foot .cf-reset:hover {
  color: var(--text-primary);
}
.col-filter .cf-foot .cf-done {
  margin-left: auto;
  font-size: 12.5px;
  font-weight: 600;
  color: #fff;
  background: var(--primary-color);
  border: none;
  border-radius: 7px;
  padding: 7px 16px;
  cursor: pointer;
}
.col-filter .cf-foot .cf-done:hover {
  background: var(--primary-color-hover);
}
.cf-row.cdk-drag-preview {
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.18);
  background: var(--background-white);
  border-radius: 8px;
}
.cf-row.cdk-drag-placeholder {
  opacity: 0.4;
}
.cf-list.cdk-drop-list-dragging .cf-row:not(.cdk-drag-placeholder) {
  transition: transform 150ms cubic-bezier(0, 0, 0.2, 1);
}
::ng-deep .ngx-datatable .datatable-body {
  max-height: 40vh !important;
  overflow: auto;
}
::ng-deep .ngx-datatable .datatable-body .datatable-body-row {
  transition: var(--transition-fast);
  border-bottom: 1px solid var(--background-lighter);
}
::ng-deep .ngx-datatable .datatable-body .datatable-body-row:hover {
  background-color: var(--primary-color-light) !important;
}
::ng-deep .ngx-datatable .datatable-body .datatable-body-row:last-child {
  border-bottom: none;
}
::ng-deep .ngx-datatable .datatable-body .datatable-body-cell {
  padding: var(--space-md) var(--space-sm);
  border-right: 1px solid var(--background-lighter);
}
::ng-deep .ngx-datatable .datatable-body .datatable-body-cell:last-child {
  border-right: none;
}
::ng-deep .ngx-datatable .datatable-body .datatable-body-cell-label {
  font-size: 13px !important;
  overflow-wrap: break-word !important;
  color: var(--text-secondary);
  line-height: 1.4;
}
::ng-deep .ngx-datatable .datatable-header {
  background: var(--background-light);
  border-bottom: 2px solid var(--background-border);
}
::ng-deep .ngx-datatable .datatable-header .datatable-header-cell {
  padding: var(--space-md) var(--space-sm);
  border-right: 1px solid var(--background-border);
}
::ng-deep .ngx-datatable .datatable-header .datatable-header-cell:last-child {
  border-right: none;
}
::ng-deep .ngx-datatable .datatable-header .datatable-header-cell-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-primary);
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
::ng-deep .ngx-datatable .datatable-header .sort-btn {
  color: var(--primary-color);
}
::ng-deep .ngx-datatable .datatable-body .loading-indicator {
  color: var(--primary-color);
}
.action-list-custom {
  display: flex;
  gap: var(--space-xs);
  justify-content: center;
}
@media (max-width: 768px) {
  .searchbar-wrapper {
    flex-direction: column;
    align-items: stretch;
  }
  .searchbar-wrapper .input-wrap {
    width: 100%;
    margin-bottom: var(--space-sm);
  }
  .column-settings-wrapper {
    right: 0;
    left: auto;
    min-width: 250px;
  }
}
/*# sourceMappingURL=datatable.component.css.map */
